// extracted by mini-css-extract-plugin
export default {"ProfileInfoContainer":"ProfileInfo_ProfileInfoContainer__pz226","info":"ProfileInfo_info__n67aj","title":"ProfileInfo_title__PnNYn"};